import React from 'react';
import { Users } from 'lucide-react';
import { BuyerDemographics } from '../../services/funnels';
import { dictionary, Language } from '../../utils/dictionary';

const COLORS = { male: '#378ADD', female: '#D4537E', unknown: '#9CA3AF' };

interface BuyerDemographicsCardProps {
	data: BuyerDemographics;
	language: Language;
}

const toNumber = (value: number | string | null | undefined): number => {
	const parsed = Number(value ?? 0);
	return Number.isFinite(parsed) ? parsed : 0;
};

const BuyerDemographicsCard: React.FC<BuyerDemographicsCardProps> = ({ data, language }) => {
	const total = toNumber(data.total);
	const rows = [
		{ key: 'male', label: dictionary['demographics-male'][language], color: COLORS.male, count: toNumber(data.male), pct: toNumber(data.male_percentage) },
		{ key: 'female', label: dictionary['demographics-female'][language], color: COLORS.female, count: toNumber(data.female), pct: toNumber(data.female_percentage) },
		{ key: 'unknown', label: dictionary['demographics-unknown'][language], color: COLORS.unknown, count: toNumber(data.unknown), pct: toNumber(data.unknown_percentage) },
	];

	return (
		<div className="bg-white rounded-[20px] shadow-sm border border-gray-200 p-6 mb-8">
			<div className="flex items-center justify-between mb-4">
				<div className="flex items-center gap-2">
					<Users size={18} className="text-gray-500" />
					<span className="text-gray-900 text-sm font-medium">{dictionary['buyer-demographics'][language]}</span>
				</div>
				<span className="text-gray-400 text-xs">
					{total.toLocaleString()} {dictionary['orders-tab']?.[language] || 'Órdenes'} · {dictionary['demographics-estimate-note'][language]}
				</span>
			</div>
			{total > 0 ? (
				<>
					<div className="flex h-4 rounded-full overflow-hidden mb-4 bg-gray-100">
						{rows.map((row) => (
							row.pct > 0 ? (
								<div key={row.key} style={{ width: `${row.pct}%`, backgroundColor: row.color }} />
							) : null
						))}
					</div>
					<div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-8">
						{rows.map((row) => (
							<div key={row.key} className="flex items-center gap-2">
								<span className="w-2.5 h-2.5 rounded-[3px] flex-shrink-0" style={{ backgroundColor: row.color }} />
								<span className="text-sm text-gray-500">{row.label}</span>
								<span className="text-sm font-medium text-gray-900">{row.count.toLocaleString()}</span>
								<span className="text-xs text-gray-400">{row.pct}%</span>
							</div>
						))}
					</div>
				</>
			) : (
				<p className="text-sm text-gray-400">{dictionary['demographics-no-data'][language]}</p>
			)}
		</div>
	);
};

export default BuyerDemographicsCard;
